import { h, ComponentChildren, JSX } from 'preact'
import cx from 'classnames'
import { useCustomContext } from '../../../../lib/context'
import styles from './index.module.css'
import { GA_EVENTS, LinkClickType } from '../../../../lib/analytics'

interface LinkProps extends JSX.HTMLAttributes {
  href: string
  children: ComponentChildren
  linkClickType: LinkClickType
}

export function Link(props: LinkProps) {
  const { href, linkClickType, children, onClick, class: c, className, ...rest } = props

  const { history, sendGaEvent } = useCustomContext()
  function handleClick(event: MouseEvent) {
    const target = event.currentTarget
    if (history && target instanceof HTMLAnchorElement) {
      event.preventDefault()

      sendGaEvent(GA_EVENTS.LINK_CLICK(linkClickType, target.pathname))

      history.push({
        pathname: target.pathname,
        search: target.search
      })
    }
    onClick && onClick(event)
  }

  const classes = cx(styles.link, c, className)

  return (
    <a href={href} onClick={handleClick} class={classes} {...rest}>
      {children}
    </a>
  )
}
